[class^='icon-'],
[class*=' icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'Liebherr-Icons-Bold-For-Link' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &:before {
    content: var(--icon-name);
  }
}

span {
  &.dark {
    color: var(--color-white);
  }

  &.disabled {
    pointer-events: none;
    color: var(--color-neutral-steel-400);
    &.dark {
      color: var(--color-neutral-steel-500);
    }
  }
}
